(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-promo-offer"] && !Shopify.designMode) return;
  try {
    
  class PromoCountdown {
    constructor(element) {
      this.element = element;
      this.launchTime = parseInt(element.dataset.launchTime) * 1000; // Convert to milliseconds
      this.daysEl = element.querySelector('[data-days]');
      this.hoursEl = element.querySelector('[data-hours]');
      this.minutesEl = element.querySelector('[data-minutes]');
      this.secondsEl = element.querySelector('[data-seconds]');

      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      const now = Date.now();
      const diff = this.launchTime - now;

      if (diff <= 0) {
        // Countdown finished - stop the timer and show zeros
        clearInterval(this.interval);
        this.daysEl.textContent = '00';
        this.hoursEl.textContent = '00';
        this.minutesEl.textContent = '00';
        this.secondsEl.textContent = '00';

        // Replace countdown container with a "Live Now" message
        const countdownContainer = this.element.closest('.promo-offer__countdown-container');
        if (countdownContainer) {
          countdownContainer.innerHTML = `
            <div class="promo-offer__live-message">
              <p style="font-size: 1.5rem; font-weight: 600; margin: 0;">🔥 PROMOTION IS NOW LIVE!</p>
              <p style="margin: 0.5rem 0 0 0;">Refresh the page to see live stock availability.</p>
            </div>
          `;
        }
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      // Hide days segment if less than 24 hours remaining
      const daysSegment = this.daysEl.closest('.promo-offer__countdown-segment');
      if (daysSegment) {
        if (days === 0) {
          daysSegment.style.display = 'none';
        } else {
          daysSegment.style.display = 'flex';
        }
      }

      this.daysEl.textContent = this.pad(days);
      this.hoursEl.textContent = this.pad(hours);
      this.minutesEl.textContent = this.pad(minutes);
      this.secondsEl.textContent = this.pad(seconds);
    }

    pad(num) {
      return num.toString().padStart(2, '0');
    }
  }

  // Initialize countdown timers
  document.addEventListener('DOMContentLoaded', () => {
    const countdowns = document.querySelectorAll('.promo-offer__countdown');
    countdowns.forEach(countdown => new PromoCountdown(countdown));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  document.addEventListener('updateShippingBar', function() {
    const shippingBar = document.querySelector('.free-shipping-bar');
    console.log('shipping event');
    if (!shippingBar) return;

    // Check if the bar is currently visible
    const isVisible = shippingBar.getAttribute('data-visible') === 'true';

    if (!isVisible) {
      // If the bar is not visible, run the entry animation
      shippingBar.setAttribute('data-visible', 'true');

      shippingBar.animate([
        { top: '-60px' },
        { top: '0' }
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards'
      });
    }

    // Clear any previous exit timeouts and set a new one
    clearTimeout(shippingBar.exitTimeout);
    shippingBar.exitTimeout = setTimeout(() => {
      shippingBar.setAttribute('data-visible', 'false');
      shippingBar.animate([
        { top: '0' },
        { top: '-60px' }
      ], {
        duration: 300,
        easing: 'ease-in-out',
        fill: 'forwards'
      });
    }, 8000); // 8 seconds

  });

  // Trigger the updateShippingBar event on initial page load
  document.dispatchEvent(new Event('updateShippingBar'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-finder"] && !Shopify.designMode) return;
  try {
    

var submitButton = document.querySelector('#gift-search input[type="submit"]');

function checkSelections() {
  var tagAValue = document.getElementById('tagA').value;
  var tagBValue = document.getElementById('tagB').value;
  var tagCValue = document.getElementById('tagC').value;

  if (tagAValue !== "" || tagBValue !== "" || tagCValue !== "") {
    submitButton.disabled = false;
  } else {
    submitButton.disabled = true;
  }
}

document.getElementById('tagA').addEventListener('change', checkSelections);
document.getElementById('tagB').addEventListener('change', checkSelections);
document.getElementById('tagC').addEventListener('change', checkSelections);


document.getElementById("gift-search").addEventListener("submit", function(event) {
    event.preventDefault();

    const tagA = document.getElementById('tagA').value ? 'tag%3A' + document.getElementById('tagA').value : '';
    const tagB = document.getElementById('tagB').value ? 'tag%3A' + document.getElementById('tagB').value : '';
    const tagC = document.getElementById('tagC').value ? 'tag%3A' + document.getElementById('tagC').value : '';

    let searchParams = [tagA, tagB, tagC].filter(Boolean).join('+AND+');
    
    window.location.href = '/search?sort_by=relevance&q=' + searchParams;
    console.log(searchParams);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-search-row"]) return;
  try {
    
document.querySelector('.drilldown-icon').addEventListener('click', function(e) {
  const backdrop = document.querySelector('drilldown-menu');
  const menu = document.querySelector('.menu-container');

  backdrop.classList.remove('closed');
  document.body.classList.add('fixed-position');
  setTimeout(() => menu.style.right = '0', 120);
});

document.querySelector('#closeButton').addEventListener('click', function() {
  const backdrop = document.querySelector('drilldown-menu');
  const menu = document.querySelector('.menu-container');

  menu.style.right = '-80vw';
  document.body.classList.remove('fixed-position');
  setTimeout(() => backdrop.classList.add('closed'), 120);
});

document.querySelector('drilldown-menu').addEventListener('click', function(e) {
  if(e.target !== e.currentTarget) return;
  if(e.target.classList.contains('closed')) return;
  const backdrop = document.querySelector('drilldown-menu');
  const menu = document.querySelector('.menu-container');
  menu.style.right = '-80vw';
  document.body.classList.remove('fixed-position');
  setTimeout(() => backdrop.classList.add('closed'), 120);
});
$(document).ready(function() {
  $('.is-drilldown-submenu-parent > a').click(function() {
    $('.is-active').removeClass('is-active');
    $(this).next('ul').addClass('is-active');
  });
  
  $('.js-drilldown-back > a').click(function() {
    $('.is-active').removeClass('is-active');
  });
});

function waitForWishlistSDK(callback, maxAttempts = 20) {
  let attempts = 0;
  
  const checkSDK = () => {
    attempts++;
    if (window.WishListHero_SDK) {
      callback();
    } else if (attempts < maxAttempts) {
      setTimeout(checkSDK, 500);
    } else {
      console.warn('WishListHero SDK not loaded after maximum attempts');
    }
  };
  
  checkSDK();
}

function updateWishlistCount() {
  waitForWishlistSDK(() => {
    try {
      const count = window.WishListHero_SDK.GetWishListItemsCount();
      const countElement = document.querySelector('.wishlist-count');
      if (countElement) {
        if (count > 0) {
          countElement.textContent = count;
          countElement.style.display = 'block';
        } else {
          countElement.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error fetching wishlist count:', error);
    }
  });
}

// Add click listeners for wishlist buttons
function setupWishlistListeners() {
  // For collection page buttons
  document.addEventListener('click', function(e) {
    if (e.target.matches('.wishlist-hero-custom-button') || 
        e.target.closest('.wishlist-hero-custom-button') ||
        e.target.matches('#wishlisthero-product-page-button-container button') ||
        e.target.closest('#wishlisthero-product-page-button-container button')) {
      setTimeout(updateWishlistCount, 500);
    }
  });

  // Add wishlist button click handler
  document.querySelector('#wishlist-button').addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default link behavior
    waitForWishlistSDK(() => {
      window.WishListHero_SDK.OpenWishList();
    });
  });
}

// Initialize everything when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  updateWishlistCount();
  setupWishlistListeners();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-gf"] && !Shopify.designMode) return;
  try {
    
console.log('ready for search');
var submitButton = document.querySelector('#gift-search input[type="submit"]');
  
function checkSelections() {
  var tagAValue = document.getElementById('tagA').value;
  var tagBValue = document.getElementById('tagB').value;
  var tagCValue = document.getElementById('tagC').value;

  if (tagAValue !== "" || tagBValue !== "" || tagCValue !== "") {
    submitButton.disabled = false;
    submitButton.value = "Find Gifts";
  } else {
    submitButton.disabled = true;
    submitButton.value = "Select your options";
  }
}

document.getElementById('tagA').addEventListener('change', checkSelections);
document.getElementById('tagB').addEventListener('change', checkSelections);
document.getElementById('tagC').addEventListener('change', checkSelections);

checkSelections();
  
document.getElementById("gift-search").addEventListener("submit", function(event) {
    event.preventDefault();

    const tagA = document.getElementById('tagA').value ? 'tag%3A%27' + document.getElementById('tagA').value + '%27' : '';
    const tagB = document.getElementById('tagB').value ? 'tag%3A%27' + document.getElementById('tagB').value + '%27' : '';
    const tagC = document.getElementById('tagC').value ? 'tag%3A%27' + document.getElementById('tagC').value + '%27' : '';

    let searchParams = [tagA, tagB, tagC].filter(Boolean).join('+AND+');

    console.log('searching... ', searchParams);
    window.location.href = '/search?sort_by=relevance&q=' + searchParams;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
$(document).ready(function() {
  $.fn.extend({
    toggleText: function(a, b){
      return this.text(this.text() == b ? a : b);
    }
  });

  // On document ready, check each button and its corresponding content
  $('.subpage-readmore-btn').each(function() {
    var descriptionDiv = $(this).prev('.collection-hero__description');
    // If the content of the div is overflowing...
    if (descriptionDiv[0].scrollHeight > descriptionDiv.height() - 30) {
      // Show this button
      $(this).show();
    }
  });

  $('.subpage-readmore-btn').click(function(e) {
    e.preventDefault();
    var descriptionDiv = $(this).prev('.collection-hero__description');
    descriptionDiv.toggleClass('expanded');
    $(this).toggleText('Read More', 'Read Less');

    // If the expanded class is currently applied...
    if (!descriptionDiv.hasClass('expanded')) {
      // Smoothly scroll the page back to the title element
      $('html, body').animate({
        scrollTop: ($('#desc_title').offset().top - 220)
      }, 200);
    }
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
/**console.log('Collection - v1.0382');
const minusButtons = document.querySelectorAll(".button-minus-qty");
const plusButtons = document.querySelectorAll(".button-plus-qty");
const checkoutButtons = document.querySelectorAll(".quick-add__submit");

minusButtons.forEach(button => {
  button.addEventListener("click", handleButtonClick);
});

plusButtons.forEach(button => {
  button.addEventListener("click", handleButtonClick);
});

checkoutButtons.forEach(button => {
  button.addEventListener("click", handleButtonClick);
});

function handleButtonClick(event) {
  event.preventDefault();
  let variantId = parseInt(event.target.getAttribute('data-vid'));
  let newQty = event.target.getAttribute('data-qty');
  let submitButton;

  console.log("Event target: ", event.target);
  console.log("Variant ID: ",variantId);
  console.log("New quantity to pass: ", newQty);

  let errorBox = document.querySelector(`.product-form__error-message-wrapper-${variantId}`);
  let errorText = errorBox.querySelector(".product-form__error-message");
  errorBox.classList.add("hidden");
  errorBox.setAttribute("hidden","");
  errorText.innerHTML = "";

  if(event.target.id == 'minus-qty' || event.target.id == 'plus-qty' ) {
    cartRoute = routes.cart_change_url;
    submitButton = event.target.closest('.quick-add').querySelector('.quick-add__submit');
  } else {
    submitButton = event.target;
    if(newQty == 1) {
      cartRoute = routes.cart_add_url;
    } else {
      cartRoute = routes.cart_change_url;
    }
  }
  console.log("SUBMIT: ", submitButton);
  submitButton.classList.add("loading");
  submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  console.log("Cart Route: ", cartRoute);
  const body = JSON.stringify({
    id: `${variantId}`,
    quantity: `${newQty}`,
    sections: ["cart-notification-product","cart-notification-button","cart-icon-bubble","card-product"],
    sections_url: window.location.pathname,
  });

  fetch(`${cartRoute}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      if (!response.ok) {
          return response.json().then(errorBody => Promise.reject(errorBody));
      }
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      let parseHTML = parsedState.sections["card-product"];
      //console.log("parsed: ",parseHTML);
      let buttonHTML = getButtonHTML(variantId, parseHTML);
      //console.log("button: ",buttonHTML);
      let cardProductTarget = document.querySelector(`.card-product-${variantId}`);
      let buttonTarget = cardProductTarget.querySelector('.product-form__buttons');
      buttonTarget.innerHTML = buttonHTML;
      submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      submitButton.classList.remove("loading");
      document.querySelector('#cart-icon-bubble').innerHTML = parsedState.sections["cart-icon-bubble"];
      const minusButtons = document.querySelectorAll(".button-minus-qty");
      const plusButtons = document.querySelectorAll(".button-plus-qty");
      const checkoutButtons = document.querySelectorAll(".quick-add__submit");
      
      minusButtons.forEach(button => {
        button.addEventListener("click", handleButtonClick);
      });
      
      plusButtons.forEach(button => {
        button.addEventListener("click", handleButtonClick);
      });

      checkoutButtons.forEach(button => {
        button.addEventListener("click", handleButtonClick);
      });
    })
    .catch((errorBody) => {
        if (errorBody) {
            const errorMsg = errorBody.errors;
            const variantId = event.target.getAttribute('data-vid');
            const errorBox = document.querySelector(`.product-form__error-message-wrapper-${variantId}`);
            errorBox.classList.remove("hidden");
            errorBox.removeAttribute("hidden");
            const errorText = errorBox.querySelector(".product-form__error-message");
            errorText.innerHTML = errorMsg;
            submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
            submitButton.classList.remove("loading");
        }
    });
}

function getButtonHTML(variantId, htmlString) {

  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlString, 'text/html'); 
  let cardProduct = doc.querySelector(`.card-product-${variantId}`);
  
  if (cardProduct) {
    let productFormButtons = cardProduct.querySelector('.product-form__buttons');
    
    if (productFormButtons) {
      return productFormButtons.innerHTML;
    }
  }
  return null;
}
**/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  console.log('main product section');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-box-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var root = document.querySelector('.mbp[data-section-id]');
  if (!root) return;
  var sid = root.dataset.sectionId;

  // ── PARTICLES ─────────────────────────────────────────────────────────
  var EMOJIS = ['❓','⭐','🎁','✨','🎉','💫','🌟','🎲','🎊'];
  var pc = document.getElementById('mbp-particles-' + sid);
  var heroWrapper = pc ? pc.parentElement : null;
  var purchaseSection = root.querySelector('.mbp__purchase-section');

  function getSpawnBottom() {
    if (!heroWrapper || !purchaseSection) return 0;
    // Distance from wrapper's bottom edge to purchase section's top edge
    return heroWrapper.offsetHeight - purchaseSection.offsetTop;
  }

  function spawnParticle() {
    if (!pc) return;
    var el = document.createElement('span');
    el.className = 'mbp-particle';
    el.textContent = EMOJIS[Math.floor(Math.random() * EMOJIS.length)];
    var dur   = (5 + Math.random() * 6).toFixed(2);
    var delay = (Math.random() * 1).toFixed(2);
    var drift = ((Math.random() - 0.5) * 100).toFixed(0);
    el.style.setProperty('--dur', dur + 's');
    el.style.setProperty('--delay', delay + 's');
    el.style.setProperty('--drift', drift + 'px');
    el.style.left = (5 + Math.random() * 90) + '%';
    el.style.bottom = getSpawnBottom() + 'px';
    pc.appendChild(el);
    setTimeout(function () { el.remove(); }, (parseFloat(dur) + parseFloat(delay)) * 1000 + 200);
  }
  for (var pi = 0; pi < 6; pi++) setTimeout(spawnParticle, pi * 250);
  setInterval(spawnParticle, 900);

  // ── CAROUSEL ──────────────────────────────────────────────────────────
  var cViewport = document.getElementById('mbp-carousel-' + sid);
  if (cViewport) {
    var cTrack = document.getElementById('mbp-carousel-track-' + sid);
    var cDots  = root.querySelectorAll('#mbp-cdots-' + sid + ' .mbp__carousel-dot');
    var cPrev  = document.getElementById('mbp-prev-' + sid);
    var cNext  = document.getElementById('mbp-next-' + sid);
    var cSlides = cTrack ? Array.from(cTrack.querySelectorAll('.mbp__carousel-slide')) : [];
    var cIdx = 0;

    function visibleSlides() { return window.innerWidth <= 749 ? 1 : 2; }

    function goCarousel(idx) {
      var max = Math.max(0, cSlides.length - visibleSlides());
      cIdx = Math.min(Math.max(0, idx), max);
      var slideW = cSlides[0] ? cSlides[0].getBoundingClientRect().width : 0;
      var gap = parseFloat(getComputedStyle(cTrack).columnGap || getComputedStyle(cTrack).gap) || 0;
      cTrack.style.transform = 'translateX(-' + (cIdx * (slideW + gap)) + 'px)';
      cDots.forEach(function (d, i) { d.classList.toggle('is-active', i === cIdx); });
    }

    if (cPrev) cPrev.addEventListener('click', function () { goCarousel(cIdx - 1); });
    if (cNext) cNext.addEventListener('click', function () { goCarousel(cIdx + 1); });
    cDots.forEach(function (d) {
      d.addEventListener('click', function () { goCarousel(parseInt(d.dataset.cslide, 10)); });
    });

    var cTouchX = 0;
    cViewport.addEventListener('touchstart', function (e) { cTouchX = e.touches[0].clientX; }, { passive: true });
    cViewport.addEventListener('touchend', function (e) {
      var diff = cTouchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? goCarousel(cIdx + 1) : goCarousel(cIdx - 1);
    }, { passive: true });

    window.addEventListener('resize', function () { goCarousel(cIdx); });
  }

  // ── BLURRED REVEAL ────────────────────────────────────────────────────
  var revealItems = root.querySelectorAll('[data-reveal-item]');

  revealItems.forEach(function (item) {
    item.addEventListener('click', function () {
      if (item.classList.contains('is-revealing')) return;
      item.classList.add('is-revealing');
      setTimeout(function () { item.classList.remove('is-revealing'); }, 2400);
    });
  });

  if ('IntersectionObserver' in window && revealItems.length) {
    var rTriggered = false;
    var rObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !rTriggered) {
          rTriggered = true;
          revealItems.forEach(function (item, i) {
            setTimeout(function () {
              item.classList.add('is-revealing');
              setTimeout(function () { item.classList.remove('is-revealing'); }, 2400);
            }, i * 340);
          });
          rObs.disconnect();
        }
      });
    }, { threshold: 0.25 });
    var rSection = root.querySelector('.mbp__reveal-section');
    if (rSection) rObs.observe(rSection);
  }

  // ── DESCRIPTION REVEAL ────────────────────────────────────────────────
  var descBody = document.getElementById('mbp-desc-body-' + sid);
  var descBtn  = document.getElementById('mbp-desc-reveal-' + sid);
  var descHide = document.getElementById('mbp-desc-hide-' + sid);
  if (descBody && descBtn && descHide) {
    descBtn.addEventListener('click', function () {
      descBody.classList.add('is-expanded');
      descBtn.classList.add('is-hidden');
      descHide.classList.remove('is-hidden');
      descBtn.setAttribute('aria-expanded', 'true');
    });
    descHide.addEventListener('click', function () {
      descBody.classList.remove('is-expanded');
      descHide.classList.add('is-hidden');
      descBtn.classList.remove('is-hidden');
      descBtn.setAttribute('aria-expanded', 'false');
    });
  }

  // ── BACK TO TOP ───────────────────────────────────────────────────────
  var backTopBtn = document.getElementById('mbp-backtop-' + sid);
  if (backTopBtn) {
    backTopBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── BOY OR GIRL CAROUSEL (mobile) ─────────────────────────────────────
  var bgGrid = document.getElementById('mbp-bg-' + sid);
  if (bgGrid) {
    var bgCards = Array.from(bgGrid.querySelectorAll('.mbp__bg-card'));
    if (bgCards.length >= 2) {
      var bgIdx = 0;
      setInterval(function () {
        if (window.innerWidth > 749) return;
        bgIdx = (bgIdx + 1) % bgCards.length;
        var target = bgCards[bgIdx];
        var gridRect = bgGrid.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        var nextLeft = bgGrid.scrollLeft + (targetRect.left - gridRect.left);
        bgGrid.scrollTo({ left: nextLeft, behavior: 'smooth' });
      }, 6000);
    }
  }

  // ── FAQ ACCORDION ─────────────────────────────────────────────────────
  var faqItems = root.querySelectorAll('[data-faq-item]');
  faqItems.forEach(function (item) {
    var btn = item.querySelector('.mbp__faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var willOpen = !item.classList.contains('is-open');
      faqItems.forEach(function (other) {
        other.classList.remove('is-open');
        var otherBtn = other.querySelector('.mbp__faq-q');
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── BNPL CAROUSEL ─────────────────────────────────────────────────────
  var bnplGrid = document.getElementById('mbp-bnpl-' + sid);
  if (bnplGrid) {
    var bnplCards = Array.from(bnplGrid.querySelectorAll('.mbp__bnpl-card'));
    var bnplActive = 0;
    var bnplPauseUntil = 0;

    function bnplActivate(idx) {
      bnplActive = idx;
      bnplCards.forEach(function (card, i) {
        card.classList.toggle('mbp__bnpl-card--active', i === idx);
      });
    }

    setInterval(function () {
      if (Date.now() < bnplPauseUntil) return;
      bnplActivate((bnplActive + 1) % bnplCards.length);
    }, 3000);

    bnplCards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (i === bnplActive) return;
        bnplActivate(i);
        bnplPauseUntil = Date.now() + 10000;
      });
    });
  }

  // ── ATC CONFETTI ──────────────────────────────────────────────────────
  var atcBtn = document.getElementById('mbp-atc-' + sid);
  var CC = ['#fff','#ffd700','#ff6b6b','#4ecdc4','#45b7d1','#fff200','#ff8c00'];

  function launchConfetti() {
    for (var i = 0; i < 75; i++) {
      (function () {
        var el = document.createElement('div');
        el.className = 'mbp-confetti';
        var size = 6 + Math.random() * 10;
        el.style.cssText = [
          'left:' + (5 + Math.random() * 90) + 'vw',
          'top:-20px',
          'width:' + size + 'px',
          'height:' + size + 'px',
          'background:' + CC[Math.floor(Math.random() * CC.length)],
          '--shape:' + (Math.random() > 0.5 ? '50%' : '2px'),
          '--dur:' + (1.8 + Math.random() * 2).toFixed(2) + 's',
          '--delay:' + (Math.random() * 0.5).toFixed(2) + 's',
          '--rot:' + ((Math.random() - 0.5) * 1440).toFixed(0) + 'deg'
        ].join(';');
        document.body.appendChild(el);
        setTimeout(function () { el.remove(); }, 4000);
      })();
    }
  }

  if (atcBtn) atcBtn.addEventListener('click', function () { if (!atcBtn.disabled) launchConfetti(); });

  // ── BOX ANIMATION ─────────────────────────────────────────────────────
  var boxScene = document.getElementById('mbp-box-' + sid);
  if (boxScene) {
    var boxStarted = false;
    var closedWrap = boxScene.querySelector('.mbp__box-closed-wrap');

    function runBoxAnimation() {
      // Step 1: shake
      closedWrap.style.animation = 'mbp-box-shake 0.85s cubic-bezier(0.4,0,0.2,1) forwards';
      setTimeout(function () {
        closedWrap.style.animation = '';
        // Step 2: lid flies off, closed box fades out
        boxScene.classList.add('is-opening');
        setTimeout(function () {
          // Step 3: open box + question mark burst
          boxScene.classList.add('is-open');
          // Step 4: after qmarks finish + 2s viewing, reset and loop
          setTimeout(function () {
            boxScene.classList.remove('is-open', 'is-opening');
            setTimeout(runBoxAnimation, 650);
          }, 4400);
        }, 430);
      }, 920);
    }

    var boxObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !boxStarted) {
        boxStarted = true;
        boxObs.disconnect();
        runBoxAnimation();
      }
    }, { threshold: 0.5 });
    boxObs.observe(boxScene);
  }

  // ── LIPSCORE REVIEW COUNT ─────────────────────────────────────────────
  var lsSrc   = document.getElementById('mbp-lipscore-src-' + sid);
  var lsLink  = document.getElementById('mbp-review-link-' + sid);
  var lsCount = document.getElementById('mbp-review-count-' + sid);
  if (lsSrc && lsLink && lsCount) {
    var extractCount = function () {
      var text = (lsSrc.innerText || lsSrc.textContent || '').trim();
      if (!text) return false;
      var m = text.match(/reviews?\s*\((\d+)\)/i);
      if (!m) {
        var all = text.match(/\((\d+)\)/g);
        if (all && all.length) {
          var last = all[all.length - 1];
          m = last.match(/\((\d+)\)/);
        }
      }
      if (m && m[1]) {
        lsCount.textContent = m[1];
        lsLink.classList.add('is-ready');
        return true;
      }
      return false;
    };
    if (!extractCount()) {
      var lsObs = new MutationObserver(function () {
        if (extractCount()) lsObs.disconnect();
      });
      lsObs.observe(lsSrc, { childList: true, subtree: true, characterData: true });
      setTimeout(function () { lsObs.disconnect(); }, 15000);
    }
  }

  // ── MOBILE STICKY ATC ─────────────────────────────────────────────────
  var mainAtc   = document.getElementById('mbp-atc-' + sid);
  var stickyBar = document.getElementById('mbp-sticky-atc-' + sid);
  var stickyBtn = document.getElementById('mbp-sticky-atc-btn-' + sid);
  if (mainAtc && stickyBar && stickyBtn && 'IntersectionObserver' in window) {
    var atcObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          }
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    atcObs.observe(mainAtc);

    stickyBtn.addEventListener('click', function () {
      if (mainAtc.disabled) return;
      mainAtc.click();
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-cart-upsells"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var addButton = document.querySelector('.upsell-wrapper #add_all_recommended');
    addButton.addEventListener('click', async function(e) {
      e.preventDefault();
      this.style.opacity = '0.65';
      this.innerHTML = 'Adding...';

      var variantId = this.getAttribute('data-bundle');
      var bundleRoute = this.getAttribute('data-route');
      var quantity = 1;

        try {
            // Await the AJAX call
            await $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: variantId,
                    quantity: quantity
                },
                dataType: 'json'
            });
            // After the AJAX call is successful
            addButton.textContent = 'Added! ✓';
            addButton.style.opacity = '1';
            // Allow UI to update before redirecting
            setTimeout(function() {
                window.location.href = '/checkout';
            }, 100); // Adjust delay as needed
        } catch (error) {
            console.error("Error:", error.statusText || "An error occurred");
            // Handle error, potentially update button text to indicate failure
            addButton.textContent = 'Add to Cart';
            addButton.style.opacity = '1';
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-threshold-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Track the previous threshold to detect crossings
  var lastPrevThreshold = null;
  var initBar = document.querySelector('.promo-threshold-bar');
  if (initBar) {
    var initData = initBar.querySelector('.promo-bar-data');
    if (initData) {
      lastPrevThreshold = parseFloat(initData.getAttribute('data-prev-threshold')) || 0;
    }
  }

  document.addEventListener('updatePromoBar', function() {
    var promoBar = document.querySelector('.promo-threshold-bar');
    if (!promoBar) return;

    // Read current threshold state from the (possibly just-replaced) inner content
    var dataSpan = promoBar.querySelector('.promo-bar-data');
    var newPrevThreshold = 0;
    if (dataSpan) {
      newPrevThreshold = parseFloat(dataSpan.getAttribute('data-prev-threshold')) || 0;
    }

    // Detect if a threshold was just crossed (prev threshold increased)
    var thresholdCrossed = lastPrevThreshold !== null && newPrevThreshold > lastPrevThreshold;
    lastPrevThreshold = newPrevThreshold;

    var metMsg = promoBar.querySelector('.promo-bar-message--met');
    var progressMsg = promoBar.querySelector('.promo-bar-message--progress');

    // If threshold crossed and we have a met message, show it first
    if (thresholdCrossed && metMsg && progressMsg) {
      metMsg.style.display = 'flex';
      progressMsg.style.display = 'none';

      clearTimeout(promoBar.metTimeout);
      promoBar.metTimeout = setTimeout(function() {
        metMsg.style.display = 'none';
        progressMsg.style.display = 'flex';
      }, 3000);
    }

    var isVisible = promoBar.getAttribute('data-visible') === 'true';

    if (!isVisible) {
      // Cancel any in-progress exit animation, then slide in
      promoBar.getAnimations().forEach(function(a) { a.cancel(); });
      promoBar.setAttribute('data-visible', 'true');
      promoBar.style.top = '0';
      promoBar.animate([
        { top: '-80px' },
        { top: '0' }
      ], {
        duration: 300,
        easing: 'ease-in-out'
      });
    }
    // If already visible, content was already replaced in the DOM — no animation needed

    // Reset the auto-hide timer so it stays visible for the full duration from now
    clearTimeout(promoBar.exitTimeout);
    var duration = parseInt(promoBar.getAttribute('data-duration')) || 8000;
    promoBar.exitTimeout = setTimeout(function() {
      promoBar.setAttribute('data-visible', 'false');
      var exitAnim = promoBar.animate([
        { top: '0' },
        { top: '-80px' }
      ], {
        duration: 300,
        easing: 'ease-in-out'
      });
      exitAnim.onfinish = function() {
        promoBar.style.top = '';
      };
    }, duration);

  });

  document.dispatchEvent(new Event('updatePromoBar'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-bar-swiper"] && !Shopify.designMode) return;
  try {
    
let swiperInstancesMob = [];
let swiperInstancesDtp = [];

// Initialize Swiper instances
let swiperMob = document.querySelector('.usp-mob');
let swiperDtp = document.querySelector('.usp-dtp');
let swiperContainersMob = swiperMob.querySelectorAll('.swiper-container');
let swiperContainersDtp = swiperDtp.querySelectorAll('.swiper-container');

swiperContainersMob.forEach((container, index) => {
  let swiper = new Swiper(container, {
    direction: 'vertical',
    slidesPerView: 1,
    autoplay: false, // Turn off internal autoplay
    loop: true
  });

  // Push the instance into the array
  swiperInstancesMob.push(swiper);
});

swiperContainersDtp.forEach((container, index) => {
  let swiper = new Swiper(container, {
    direction: 'vertical',
    slidesPerView: 1,
    autoplay: false, // Turn off internal autoplay
    loop: true
  });

  // Push the instance into the array
  swiperInstancesDtp.push(swiper);
});

// Define a function for starting autoplay
let autoplayMob = () => {
  swiperInstancesMob.forEach((swiper, index) => {
    setTimeout(() => {
      swiper.slideNext(); // Slide to next slide
    }, index * 205); // Set the delay between each transition
  });
};

let autoplayDtp = () => {
  swiperInstancesDtp.forEach((swiper, index) => {
    setTimeout(() => {
      swiper.slideNext(); // Slide to next slide
    }, index * 205); // Set the delay between each transition
  });
};

// Start autoplay
setInterval(autoplayMob, 3000);
setInterval(autoplayDtp, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.wshReady) return;
      root.dataset.wshReady = '1';
      const track = root.querySelector('[data-wsh-track]');
      const slides = [...track.children];
      if (slides.length < 2) return;
      const dotList = root.querySelector('[data-wsh-dots]');
      const tabList = root.querySelector('[data-wsh-tabs]');
      const pauseBtn = root.querySelector('[data-wsh-pause]');
      const delay = Number(root.dataset.autoplay) || 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.style.setProperty('--wsh-dur', `${delay}ms`);

      const makeButton = (cls, html, label, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = cls;
        if (html) b.innerHTML = html;
        if (label) b.setAttribute('aria-label', label);
        b.addEventListener('click', () => go(i, true));
        return b;
      };
      const esc = (s) => s.replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[ch]);
      const dots = slides.map((s, i) => dotList.appendChild(makeButton('wsh__dot', '', `Show ${s.dataset.tab}`, i)));
      const tabs = tabList ? slides.map((s, i) => tabList.appendChild(makeButton('wsh__tab', `${esc(s.dataset.tab)}<span class="wsh__tab-bar"></span>`, '', i))) : [];

      let index = -1;
      let timer = null;
      let userPaused = reduced || !delay;
      let held = false;

      function schedule() {
        clearTimeout(timer);
        const playing = !userPaused && !held;
        root.classList.toggle('is-playing', playing);
        root.classList.toggle('is-paused', userPaused);
        if (playing) timer = setTimeout(() => go(index + 1), delay);
      }
      function setActive(i) {
        if (i === index) return;
        index = i;
        slides.forEach((s, n) => s.toggleAttribute('inert', n !== i));
        [dots, tabs].forEach((list) => list.forEach((b, n) => {
          b.classList.toggle('is-active', n === i);
          if (n === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        }));
        [dots[i], tabs[i] && tabs[i].querySelector('.wsh__tab-bar')].forEach((el) => {
          if (!el) return;
          el.style.animation = 'none';
          void el.offsetWidth;
          el.style.animation = '';
        });
        if (tabList && tabList.scrollWidth > tabList.clientWidth) {
          tabList.scrollTo({ left: tabs[i].offsetLeft - (tabList.clientWidth - tabs[i].offsetWidth) / 2, behavior: 'smooth' });
        }
        schedule();
      }
      function go(i, fromUser) {
        const n = (i + slides.length) % slides.length;
        track.scrollTo({ left: n * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        setActive(n);
        if (fromUser) schedule();
      }

      let scrollEnd;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollEnd);
        scrollEnd = setTimeout(() => setActive(Math.round(track.scrollLeft / track.clientWidth)), 80);
      }, { passive: true });
      root.querySelector('[data-wsh-prev]').addEventListener('click', () => go(index - 1, true));
      root.querySelector('[data-wsh-next]').addEventListener('click', () => go(index + 1, true));
      if (pauseBtn) {
        if (reduced) pauseBtn.hidden = true;
        pauseBtn.addEventListener('click', () => {
          userPaused = !userPaused;
          pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
          schedule();
        });
      }
      const hold = (v) => { held = v; schedule(); };
      root.addEventListener('mouseenter', () => hold(true));
      root.addEventListener('mouseleave', () => hold(false));
      root.addEventListener('focusin', () => hold(true));
      root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) hold(false); });
      track.addEventListener('touchstart', () => hold(true), { passive: true });
      track.addEventListener('touchend', () => setTimeout(() => hold(false), 2500), { passive: true });
      document.addEventListener('visibilitychange', () => hold(document.hidden));
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') go(index + 1, true);
        if (e.key === 'ArrowLeft') go(index - 1, true);
      });
      window.addEventListener('resize', () => track.scrollTo({ left: index * track.clientWidth }));

      // Theme editor: selecting a slide block shows it and stops autoplay while editing
      root.wshShow = (el) => {
        const i = slides.indexOf(el);
        if (i < 0) return;
        userPaused = true;
        go(i, true);
      };
      setActive(0);
    }

    const initAll = () => document.querySelectorAll('[data-wsh]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', (e) => {
      const root = e.target.closest('[data-wsh]');
      if (root && root.wshShow) root.wshShow(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
